const TIME_LOG_ACTION_TYPES = [
  { value: 'add_entry', label: 'oprettede' },
  { value: 'create_entry', label: 'registrerede' },
  { value: 'update_entry', label: 'rettede' },
  { value: 'delete_entry', label: 'slettede' },
];

export default TIME_LOG_ACTION_TYPES;
